import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

import Loading from "./Loading";
import PostMediaCard from "./PostMediaCard";

const PostDetail = () => {
  const [detailData, setDetailData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams(); // Using useParams hook for v6

  useEffect(() => {
    // **THE FIX: Use https for the API call**
    axios
      .get(`https://www.mrapi.mruns.com/wp-json/wp/v2/posts?slug=${id}&_embed`)
      .then((response) => {
        setDetailData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("ERROR");
        console.log(error);
      });
  }, [id]); // Dependency array with 'id'

  return (
    <>
      <Container sx={{ paddingTop: 2, paddingBottom: 2 }} maxWidth='md'>
        <Grid container spacing={2} direction='row' alignItems='stretch'>
          {loading ? <Loading /> : ""}
          {detailData.map((data) => {
            const imageUrl = data._embedded?.['wp:featuredmedia']?.[0]?.source_url;
            return (
              <Grid item key={data.id} xs={12}>
                <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                  <CardContent sx={{ justifyContent: "center", textAlign: "center" }}>
                    <Typography gutterBottom variant='h4'>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.title.rendered,
                        }}
                      />
                    </Typography>
                  </CardContent>
                  <CardContent sx={{ justifyContent: "center", textAlign: "center" }}>
                    <PostMediaCard imageUrl={imageUrl} />
                  </CardContent>

                  <CardContent sx={{ flexGrow: 1 }}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.content.rendered,
                      }}
                    />
                  </CardContent>
                  <CardActions>
                    <Button size='small' color='primary' component={Link} to='/'>
                      Home
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      </Container>
    </>
  );
};

export default PostDetail;
